// This function allow to reference chunks
__webpack_require__.miniCssF = (chunkId) => {
  // return url for filenames not based on template
  
  // return url for filenames based on template
  return "static/" + chunkId + "." + chunkId + "." + {"1762": "fdccbb6b901f","6638": "a7c322f609c8","8988": "29d32ed3b77c",}[chunkId] + ".css"
}